import React from "react";
import { Plus, Sparkles } from "lucide-react";
import { Button } from "../../../components/ui/button";

function EmptyIllustration() {
  return (
    <div
      className="relative mx-auto mb-6 flex h-40 w-36 items-center justify-center"
      aria-hidden
    >
      <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-violet-100 to-indigo-100 shadow-sm" />
      <div className="relative flex flex-col items-center gap-2 pt-4">
        <div className="flex h-10 w-8 rounded border border-indigo-200 bg-white shadow-sm" />
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex h-6 w-24 items-center rounded bg-white/90 px-2 shadow-sm ring-1 ring-indigo-100"
          >
            <span className="h-2 w-2 rounded-full bg-emerald-500" />
            <span className="ml-2 h-1 flex-1 rounded bg-indigo-100" />
          </div>
        ))}
      </div>
      <div className="absolute -right-1 -top-1 flex h-9 w-9 items-center justify-center rounded-full bg-violet-600 text-white shadow-md">
        <Plus className="h-5 w-5" />
      </div>
    </div>
  );
}

export function TestPlanEmptyState({ onAddTestPlan, canAdd = true }) {
  return (
    <div
      className="grid grid-cols-1 gap-6 lg:grid-cols-10 lg:items-stretch"
      data-testid="test-plan-empty-state"
    >
      <div className="flex min-h-[320px] flex-col justify-center rounded-xl border border-gray-200/80 bg-gray-50/80 p-8 shadow-sm lg:col-span-7">
        <EmptyIllustration />
        <h2 className="text-center text-xl font-bold text-gray-900">
          No Test Plan yet
        </h2>
        <p className="mx-auto mt-3 max-w-md text-center text-sm text-gray-600">
          There aren&apos;t any test plan. Use the below buttons to create the
          first test plan!
        </p>
        {canAdd && (
          <div className="mt-8 flex justify-center">
            <Button
              type="button"
              onClick={onAddTestPlan}
              className="rounded-lg bg-violet-600 px-6 text-white hover:bg-violet-700"
              data-testid="empty-add-test-plan"
            >
              <Plus className="mr-2 h-4 w-4" />+ Add Test Plans
            </Button>
          </div>
        )}
      </div>
      <div className="flex flex-col justify-center rounded-xl border border-gray-200/80 bg-gray-50/80 p-6 shadow-sm lg:col-span-3">
        <div className="mb-4 flex justify-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-sm">
            <Sparkles className="h-7 w-7" />
          </span>
        </div>
        <h3 className="text-center text-lg font-bold text-gray-900">
          What is test plan?
        </h3>
        <p className="mt-3 text-left text-sm leading-relaxed text-gray-600">
          A Test Plan is a high-level container that defines the scope,
          objective, timeline, and configuration of testing activities.
        </p>
      </div>
    </div>
  );
}
